// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".teaser[data-v-f0eb4d0c]{display:flex;flex-direction:column;align-items:center;justify-content:center;grid-gap:12px;gap:12px;max-width:800px;margin:auto;padding:20px}.teaser h2[data-v-f0eb4d0c]{font-size:32px;text-transform:uppercase;font-weight:900;color:#8a0ffe;text-align:center}.teaser.red-header h2[data-v-f0eb4d0c]{color:#d43a5e}", ""]);
// Exports
module.exports = exports;
